export default __webpack_public_path__ + "static/media/859.0d822039.png";